import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CartSidebar from 'components/CartSidebar';
import classNames from 'classnames';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import 'assets/css/header.css';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cartWidth: null,
			cartData: null,
			is_guest: true,
			headerSidebarWidth: '0px',
			userName: null
		};
	}
	componentDidMount() {
		let is_guest = localStorage.getItem('is_guest');
		let userName = localStorage.getItem('name');
		let isGuest = true;
		if (is_guest) isGuest = JSON.parse(is_guest);
		this.setState({ is_guest: isGuest, userName });

		if (!this.props.cartData) {
			this.props.setCartDataLoader(true);
			this.props.getCartData();
		}
	}
	componentDidUpdate(prevProps) {
		if ((!this.state.cartData && this.props.cartData) || prevProps.cartData !== this.props.cartData) {
			this.setState({ cartData: this.props.cartData });
		}
	}
	handleCartOpen = () => {
		let deviceWidth = window.innerWidth;
		let sidebarWidth = deviceWidth < 768 ? '100%' : '480px';
		document.getElementById('root').style.overflow = 'hidden';
		document.getElementById('overlay').style.display = 'block';
		this.setState({ cartWidth: sidebarWidth });
	};
	handleCartClose = () => {
		document.getElementById('root').style.overflow = 'auto';
		document.getElementById('overlay').style.display = 'none';
		this.setState({ cartWidth: '0px' });
	};
	handleSidebarOpen = () => {
		let deviceWidth = window.innerWidth;
		let headerSidebarWidth = '90%';
		if (deviceWidth > 480) headerSidebarWidth = '80%';
		if (deviceWidth > 600) headerSidebarWidth = '60%';
		if (deviceWidth > 700) headerSidebarWidth = '55%';
		if (deviceWidth > 800) headerSidebarWidth = '48%';
		this.setState({ headerSidebarWidth });
	};
	handleSidebarClose = () => {
		this.setState({ headerSidebarWidth: '0px' });
	};
	logoutUser = () => {
		delete localStorage.is_guest;
		delete localStorage.name;
		delete localStorage.email;

		window.location.reload();
	};
	render() {
		const { from, link } = this.props;
		const { cartWidth, is_guest, headerSidebarWidth, userName, cartData } = this.state;

		console.log(cartData);

		return (
			<div className="header-section">
				{/* Navbar Start */}
				<nav className="navbar navbar-expand-lg navbar-light site-header relative fixed-top" id="mainNavbar">
					<Link className="navbar-brand logo" to="/">
						<img src={require('assets/imgs/logo.png')} alt="logo" className="" />
					</Link>

					<button
						className="navbar-toggler"
						type="button"
						data-toggle="collapse"
						// data-target="#navbarNavAltMarkup"
						// aria-controls="navbarNavAltMarkup"
						aria-expanded="false"
						aria-label="Toggle navigation"
						onClick={this.handleSidebarOpen}
					>
						<span className="navbar-toggler-icon" />
					</button>

					{/* Mobile sidebar header ends */}
					<div className="headerSidebar" style={{ width: headerSidebarWidth }}>
						<div className="userSection">
							{!is_guest ? (
								<React.Fragment>
									<div className="d-flex flex-row align-items-center justify-content-between mb-2">
										<h1 className="m-0">
											<i className="fa fa-user mr-1" />
											{userName}
										</h1>
										<i className="fa fa-close closeIcon" onClick={this.handleSidebarClose} />
									</div>
									<Link to="/myaccount#1">Accounts</Link>
									<Link to="/myaccount#2">Orders</Link>
									<p className="link m-0" onClick={this.logoutUser}>
										Logout
									</p>
								</React.Fragment>
							) : (
								<div className="d-flex align-items-center justify-content-end">
									<i className="fa fa-close closeIcon" onClick={this.handleSidebarClose} />
								</div>
							)}
						</div>
						<div className="linksSection">
							<Link className={classNames(link === '/' && 'active')} to="/">
								Home
							</Link>
							<Link className={classNames(link === '/category/someID' && 'active')} to="/category/someID">
								Products
							</Link>
							<Link className={classNames(link === '/about-us' && 'active')} to="/about-us">
								About Us
							</Link>
							<Link className={classNames(link === '/contact-us' && 'active')} to="/contact-us">
								Contact Us
							</Link>

							{is_guest && (
								<Link className={classNames(link === '/login' && 'active')} to="/login">
									Login / Signup
								</Link>
							)}
						</div>
					</div>
					{/* Mobile sidebar header ends */}

					{/* Desktop header starts */}
					<div className="collapse navbar-collapse" id="navbarNavAltMarkup">
						<div className="navbar-nav ml-lg-4 mt-lg-3 header-nav">
							<Link
								className={classNames('nav-item nav-link px-lg-3', from === 'home' && 'active')}
								to="/"
							>
								Home
							</Link>
							<Link
								className={classNames('nav-item nav-link px-lg-3', from === 'category' && 'active')}
								to="/category/someID"
							>
								Products
							</Link>
							<Link
								className={classNames('nav-item nav-link px-lg-3', from === 'about-us' && 'active')}
								to="about-us"
							>
								About Us
							</Link>
							<Link
								className={classNames('nav-item nav-link px-lg-3', from === 'contact-us' && 'active')}
								to="/contact-us"
							>
								Contact Us
							</Link>
						</div>
					</div>
					{/* Desktop header ends */}

					<div className="cart-logo-section">
						<div className="d-none d-lg-block">
							{!is_guest ? (
								<div className="dropdown mr-3">
									<div
										className="dropdown-toggle nav-item nav-link mx-2"
										type="button"
										id="dropdownMenuButton"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<i className="fa fa-user mr-1" />
										{userName}
									</div>
									<div
										className="dropdown-menu p-2"
										aria-labelledby="dropdownMenuButton"
										style={{ minWidth: '100%', borderRadius: 0, left: 4 }}
									>
										<Link to="/myaccount#1" className="nav-item nav-link">
											Accounts
										</Link>
										<Link to="/myaccount#2" className="nav-item nav-link">
											Orders
										</Link>
										<div className="nav-item nav-link pointer" onClick={this.logoutUser}>
											Logout
										</div>
									</div>
								</div>
							) : (
								<Link
									className={classNames('nav-item nav-link mr-4', link === '/login' && 'active')}
									to="/login"
								>
									Login / Signup
								</Link>
							)}
						</div>

						<div onClick={this.handleCartOpen} className="cont pointer">
							<img src={require('assets/imgs/cartIcon.svg')} alt="cartIcon" className="" />
							{cartData &&
							cartData.products &&
							Object.keys(cartData.products).length > 0 && (
								<div className="count">
									<span>{Object.keys(cartData.products).length}</span>
								</div>
							)}
						</div>
					</div>
				</nav>
				{/* Navbar End */}

				{/* Cart Sidebar start */}
				<CartSidebar
					handleCartClose={this.handleCartClose}
					cartWidth={cartWidth}
					cartData={cartData}
					history={this.props.history}
				/>
				{/* Cart Sidebar ends */}
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getCartData: Actions.getCartData,
			setCartDataLoader: Actions.setCartDataLoader
		},
		dispatch
	);
}
function mapStateToProps(reducer) {
	const cartReducer = reducer.cartReducer;
	return {
		loadingCartData: cartReducer.loadingCartData,
		cartData: cartReducer.cartData
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);
